export default __webpack_public_path__ + "static/media/page-title-bg-03.75b5abb8.jpg";